import {
    ComponentRef,
    DestroyRef,
    Directive,
    OnInit,
    Renderer2,
    ViewContainerRef,
    inject,
    input,
    output,
} from '@angular/core';
import { outputToObservable, takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { AnyCardComponent, ICard } from '../_shared/models/card/card.model';
import { ImageData } from '../_shared/models/image/image-data.model';
import { UtilityService } from '../_shared/services/utility.service';
import { CardContainer } from '../_shared/types/card/card-container.type';
import { CardSize } from '../_shared/types/card/card-size.type';
import { CardCatalogueDataSource } from '../_shared/types/card-grid-data-source.type';
import { setComponentInputs } from '../_shared/utils/set-component-inputs';

import { CardService } from './card.service';

@Directive({
    standalone: true,
    selector: '[siriusCardElement]',
})
export class CardElementDirective implements OnInit {
    private _container = inject(ViewContainerRef);
    private _renderer = inject(Renderer2);
    private _utilityService = inject(UtilityService);
    private _cardService = inject(CardService);
    private _destroyRef = inject(DestroyRef);

    readonly config = input<ICard | undefined>(undefined);
    readonly imageData = input<ImageData | undefined>(undefined);
    readonly cardSize = input<CardSize>('');
    readonly containerType = input<CardContainer>('slider');
    readonly cardCount = input(0);
    readonly dataSource = input<CardCatalogueDataSource>('other');

    readonly selectEvent = output<void>();

    ngOnInit(): void {
        const config = this.config();
        if (!config) return;

        const cardType = this._cardService.getCard(config.cardType);
        if (!cardType) {
            throw new Error('Using unsupported card type: ' + config.cardType);
        }

        const card: ComponentRef<AnyCardComponent> = this._container.createComponent(cardType);

        setComponentInputs(card, {
            config,
            imageData: this.imageData(),
            dataSource: this.dataSource(),
            container: this.containerType(),
        });

        outputToObservable(card.instance.selectEvent)
            .pipe(takeUntilDestroyed(this._destroyRef))
            .subscribe(() => this.selectEvent.emit());

        const countWord = this._utilityService.getNumberAsWord(this.cardCount());
        const hostElement = card.location.nativeElement;
        this._renderer.addClass(hostElement, 'sir-' + this.cardSize());
        this._renderer.addClass(hostElement, 'sir-' + this.containerType());
        this._renderer.addClass(hostElement, 'sir-' + countWord);
    }
}
